import { render } from "./ProjectRow.vue?vue&type=template&id=07084c34&scoped=true"
import script from "./ProjectRow.vue?vue&type=script&lang=js"
export * from "./ProjectRow.vue?vue&type=script&lang=js"

import "./ProjectRow.vue?vue&type=style&index=0&id=07084c34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07084c34"]])

export default __exports__